<!--
 * @Description:
 * @Author: xiawenlong
 * @Date: 2021-07-13 09:17:17
 * @LastEditors: xiawenlong
 * @LastEditTime: 2026-05-09 10:01:58
-->

<template>
  <div class="Purchasing">
    <div class="title">
      <span>客户采购额</span>
    </div>
    <div class="content">
      <div class="buyer-list">
        <div
          v-for="(item, index) in data"
          :key="index"
          :class="['buyer-item', { active: index == currentIndex }]"
          @click="selectBuyer(index)"
        >
          <div class="name">{{ item.orgName }}</div>
          <div class="num">
            <span class="amount">{{ item.totalCost }}</span
            ><span class="unit">万元</span>
          </div>
        </div>
      </div>
      <div class="charts">
        <div id="PurchasingChart"></div>
      </div>
    </div>
  </div>
</template>
<script>
import * as echarts from 'echarts'
import 'echarts-gl'
let myChart
import { buyerMonth } from '@/api/agriculture-dashboard'
import to from 'await-to'
const colorMap = [
  'rgba(0, 153, 245, 0.75)',
  'rgba(75, 215, 130, 0.75)',
  'rgba(0, 100, 200, 0.75)',
  'rgba(255, 193, 7, 0.75)',
  'rgba(0, 200, 180, 0.75)',
]
export default {
  data() {
    return {
      autoSwitchTimer: null,
      totalNum: 0,
      optionData: [
        {
          name: '蔬菜水果',
          value: 19,
          itemStyle: {
            color: '#A4E1FF',
          },
        },
        {
          name: '肉蛋家禽',
          value: 13,
          itemStyle: {
            color: '#DEBB58',
          },
        },
        {
          name: '米面粮油',
          value: 15,
          itemStyle: {
            color: '#00E0DB',
          },
        },
        {
          name: '鱼虾水产',
          value: 16,
          itemStyle: {
            color: '#4BD782',
          },
        },
        {
          name: '豆制品类',
          value: 5,
          itemStyle: {
            color: '#0099F5',
          },
        },
        {
          name: '菌菇干货',
          value: 19,
        },
        {
          name: '茶叶醇香',
          value: 13,
        },
        {
          name: '地方特色',
          value: 15,
        },
      ],
      data: [
        {
          name: '武汉京膳房酒店管理有限公司',
        },
        {
          name: '武汉希尔顿酒店管理有限公司',
        },
        {
          name: '武汉锦辰水墨江南酒店管理有限公司',
        },
        {
          name: '武汉艳阳天餐饮管理有限公司',
        },
        {
          name: '武汉希尔顿酒店管理有限公司',
        },
        {
          name: '武汉科技大学后勤集团有限公司',
        },
        {
          name: '武汉京膳房酒店管理有限公司',
        },
        {
          name: '武汉希尔顿酒店管理有限公司',
        },
      ],
      currentIndex: 0,
    }
  },
  async mounted() {
    myChart = echarts.init(document.getElementById('PurchasingChart'))
    myChart.resize()
    window.addEventListener('resize', () => {
      myChart.resize()
    })
    await this.initData()
    this.bindListen(myChart)
    this.startAutoSwitch()
    setInterval(() => {
      this.initData()
    }, process.env.VUE_APP_LTIME)
  },
  methods: {
    async initData() {
      const [res, err] = await to(buyerMonth({}))
      if (err) return
      this.data = res.data
      this.setOption()
    },
    setOption() {
      this.optionData = this.data[this.currentIndex].productBuyInfoList.map((item, index) => {
        if (index < colorMap.length) {
          return {
            name: item.typeName,
            value: item.purchaseQuantity,
            itemStyle: {
              color: colorMap[index],
            },
          }
        } else {
          return {
            name: item.typeName,
            value: item.purchaseQuantity,
          }
        }
      })
      this.option = this.getPie3D(this.optionData, 0.85)
      myChart.setOption(this.option, true)
    },
    getPie3D(pieData, internalDiameterRatio) {
      let that = this
      let series = []
      let sumValue = 0
      let startValue = 0
      let endValue = 0
      let legendData = []
      let legendBfb = []
      let k = 1 - internalDiameterRatio
      pieData.sort((a, b) => {
        return b.value - a.value
      })
      for (let i = 0; i < pieData.length; i++) {
        sumValue += pieData[i].value
        let seriesItem = {
          name: typeof pieData[i].name === 'undefined' ? `series${i}` : pieData[i].name,
          type: 'surface',
          parametric: true,
          wireframe: {
            show: false,
          },
          shading: 'realistic',
          animation: false,
          pieData: pieData[i],
          pieStatus: {
            selected: false,
            hovered: false,
            k: k,
          },
        }

        if (typeof pieData[i].itemStyle != 'undefined') {
          let itemStyle = {}
          typeof pieData[i].itemStyle.color != 'undefined'
            ? (itemStyle.color = pieData[i].itemStyle.color)
            : null
          typeof pieData[i].itemStyle.opacity != 'undefined'
            ? (itemStyle.opacity = pieData[i].itemStyle.opacity)
            : null
          seriesItem.itemStyle = itemStyle
        }
        series.push(seriesItem)
      }

      legendData = []
      legendBfb = []
      const fixedHeight = 30
      for (let i = 0; i < series.length; i++) {
        endValue = startValue + series[i].pieData.value
        series[i].pieData.startRatio = startValue / sumValue
        series[i].pieData.endRatio = endValue / sumValue
        series[i].parametricEquation = this.getParametricEquation(
          series[i].pieData.startRatio,
          series[i].pieData.endRatio,
          false,
          false,
          k,
          fixedHeight,
        )
        startValue = endValue
        let bfb = that.fomatFloat(series[i].pieData.value / sumValue, 4)
        legendData.push({
          name: series[i].name,
          value: bfb,
        })
        legendBfb.push({
          name: series[i].name,
          value: bfb,
        })
      }
      let boxHeight = this.getHeight3D(series, 25)
      let option = {
        legend: {
          orient: 'horizontal',
          bottom: 0,
          left: 50,
          itemHeight: 20,
          itemWidth: 20,
          icon: 'rect',
          height: 120,
          itemGap: 20,
          formatter: function(name) {
            const legendItem = legendData.find(item => item.name === name)
            if (legendItem) {
              const percentage = (parseFloat(legendItem.value) * 100).toFixed(0)
              return `${name} ${percentage}%`
            }
            return name
          },
          textStyle: {
            fontSize: 20,
            color: '#899DBF',
            fontFamily: 'Source Han Sans CN',
            width: 220,
          },
          data: legendData,
        },
        tooltip: {
          formatter: params => {
            if (params.seriesName !== 'mouseoutSeries' && params.seriesName !== 'pie2d') {
              let bfb = (
                (option.series[params.seriesIndex].pieData.endRatio -
                  option.series[params.seriesIndex].pieData.startRatio) *
                100
              ).toFixed(2)
              return (
                `${params.seriesName}<br/>` +
                `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${params.color};"></span>` +
                `${bfb}`
              )
            }
          },
        },
        xAxis3D: {
          min: -1,
          max: 1,
        },
        yAxis3D: {
          min: -1,
          max: 1,
        },
        zAxis3D: {
          min: -1,
          max: 1,
        },
        grid3D: {
          show: false,
          boxHeight: boxHeight,
          top: '0%',
          left: '0%',
          viewControl: {
            alpha: 34,
            distance: 260,
            rotateSensitivity: 0,
            zoomSensitivity: 0,
            panSensitivity: 0,
            autoRotate: false,
          },
        },
        series: series,
      }
      return option
    },

    getHeight3D(series, height) {
      if (!series.length) return 0
      let maxValue = 0
      let minValue = Infinity
      for (let i = 0; i < series.length; i++) {
        if (series[i].pieData.value > maxValue) {
          maxValue = series[i].pieData.value
        }
        if (series[i].pieData.value < minValue) {
          minValue = series[i].pieData.value
        }
      }
      return height
    },

    getParametricEquation(startRatio, endRatio, isSelected, isHovered, k, h) {
      let midRatio = (startRatio + endRatio) / 2
      let startRadian = startRatio * Math.PI * 2
      let endRadian = endRatio * Math.PI * 2
      let midRadian = midRatio * Math.PI * 2
      if (startRatio === 0 && endRatio === 1) {
        isSelected = false
      }
      k = typeof k !== 'undefined' ? k : 1 / 3
      let offsetX = isSelected ? Math.cos(midRadian) * 0.1 : 0
      let offsetY = isSelected ? Math.sin(midRadian) * 0.1 : 0
      let hoverRate = isHovered ? 1.05 : 1
      return {
        u: {
          min: -Math.PI,
          max: Math.PI * 3,
          step: Math.PI / 32,
        },
        v: {
          min: 0,
          max: Math.PI * 2,
          step: Math.PI / 20,
        },
        x: function(u, v) {
          if (u < startRadian) {
            return offsetX + Math.cos(startRadian) * (1 + Math.cos(v) * k) * hoverRate
          }
          if (u > endRadian) {
            return offsetX + Math.cos(endRadian) * (1 + Math.cos(v) * k) * hoverRate
          }
          return offsetX + Math.cos(u) * (1 + Math.cos(v) * k) * hoverRate
        },
        y: function(u, v) {
          if (u < startRadian) {
            return offsetY + Math.sin(startRadian) * (1 + Math.cos(v) * k) * hoverRate
          }
          if (u > endRadian) {
            return offsetY + Math.sin(endRadian) * (1 + Math.cos(v) * k) * hoverRate
          }
          return offsetY + Math.sin(u) * (1 + Math.cos(v) * k) * hoverRate
        },
        z: function(u, v) {
          if (u < -Math.PI * 0.5) {
            return Math.sin(u)
          }
          if (u > Math.PI * 2.5) {
            return Math.sin(u) * h * 0.05
          }
          return Math.sin(v) > 0 ? 1 * h * 0.05 : -1
        },
      }
    },

    fomatFloat(num, n) {
      var f = parseFloat(num)
      if (isNaN(f)) {
        return false
      }
      f = Math.round(num * Math.pow(10, n)) / Math.pow(10, n)
      var s = f.toString()
      var rs = s.indexOf('.')
      if (rs < 0) {
        rs = s.length
        s += '.'
      }
      while (s.length <= rs + n) {
        s += '0'
      }
      return s
    },
    selectBuyer(index) {
      this.currentIndex = index
      this.setOption()
      const activeItem = document.querySelectorAll('.buyer-item')[this.currentIndex]
      activeItem.scrollIntoView({ behavior: 'smooth', block: 'start' })
      this.startAutoSwitch()
    },
    startAutoSwitch() {
      if (this.autoSwitchTimer) {
        clearInterval(this.autoSwitchTimer)
      }
      this.autoSwitchTimer = setInterval(() => {
        this.currentIndex++
        if (this.currentIndex >= this.data.length) {
          this.currentIndex = 0
        }
        this.setOption()
        const activeItem = document.querySelectorAll('.buyer-item')[this.currentIndex]
        activeItem.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }, 4000)
    },
    bindListen(myChart) {
      let that = this
      let selectedIndex = ''
      let hoveredIndex = ''
      let isProcessing = false
      myChart.on('click', function(params) {
        if (isProcessing) return
        if (params.seriesName === 'mouseoutSeries' || params.seriesName === 'pie2d') return
        isProcessing = true
        let isSelected = !that.option.series[params.seriesIndex].pieStatus.selected
        let isHovered = that.option.series[params.seriesIndex].pieStatus.hovered
        let k = that.option.series[params.seriesIndex].pieStatus.k
        let startRatio = that.option.series[params.seriesIndex].pieData.startRatio
        let endRatio = that.option.series[params.seriesIndex].pieData.endRatio
        if (selectedIndex !== '' && selectedIndex !== params.seriesIndex) {
          that.option.series[selectedIndex].parametricEquation = that.getParametricEquation(
            that.option.series[selectedIndex].pieData.startRatio,
            that.option.series[selectedIndex].pieData.endRatio,
            false,
            false,
            k,
            30,
          )
          that.option.series[selectedIndex].pieStatus.selected = false
        }
        that.option.series[params.seriesIndex].parametricEquation = that.getParametricEquation(
          startRatio,
          endRatio,
          isSelected,
          isHovered,
          k,
          30,
        )
        that.option.series[params.seriesIndex].pieStatus.selected = isSelected
        isSelected ? (selectedIndex = params.seriesIndex) : null
        myChart.setOption(that.option, { lazyUpdate: true })
        setTimeout(() => {
          isProcessing = false
        }, 100)
      })
      myChart.on('mouseover', function(params) {
        if (hoveredIndex === params.seriesIndex) {
          return
        } else {
          if (hoveredIndex !== '') {
            let prevSelected = that.option.series[hoveredIndex].pieStatus.selected
            let prevStartRatio = that.option.series[hoveredIndex].pieData.startRatio
            let prevEndRatio = that.option.series[hoveredIndex].pieData.endRatio
            let prevK = that.option.series[hoveredIndex].pieStatus.k
            that.option.series[hoveredIndex].parametricEquation = that.getParametricEquation(
              prevStartRatio,
              prevEndRatio,
              prevSelected,
              false,
              prevK,
              30,
            )
            that.option.series[hoveredIndex].pieStatus.hovered = false
            hoveredIndex = ''
          }
          if (params.seriesName !== 'mouseoutSeries' && params.seriesName !== 'pie2d') {
            let isSelected = that.option.series[params.seriesIndex].pieStatus.selected
            let startRatio = that.option.series[params.seriesIndex].pieData.startRatio
            let endRatio = that.option.series[params.seriesIndex].pieData.endRatio
            let k = that.option.series[params.seriesIndex].pieStatus.k
            that.option.series[params.seriesIndex].parametricEquation = that.getParametricEquation(
              startRatio,
              endRatio,
              isSelected,
              true,
              k,
              40,
            )
            that.option.series[params.seriesIndex].pieStatus.hovered = true
            hoveredIndex = params.seriesIndex
          }
          myChart.setOption(that.option, { lazyUpdate: true })
        }
      })
      myChart.on('globalout', function() {
        if (hoveredIndex !== '') {
          let prevSelected = that.option.series[hoveredIndex].pieStatus.selected
          let prevStartRatio = that.option.series[hoveredIndex].pieData.startRatio
          let prevEndRatio = that.option.series[hoveredIndex].pieData.endRatio
          let prevK = that.option.series[hoveredIndex].pieStatus.k
          that.option.series[hoveredIndex].parametricEquation = that.getParametricEquation(
            prevStartRatio,
            prevEndRatio,
            prevSelected,
            false,
            prevK,
            30,
          )
          that.option.series[hoveredIndex].pieStatus.hovered = false
          hoveredIndex = ''
        }
        myChart.setOption(that.option, { lazyUpdate: true })
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.Purchasing {
  position: relative;
  height: 100%;
  box-sizing: border-box;

  .title {
    position: relative;
    width: 100%;
    height: 70px;
    border-radius: 7px 7px 0px 0px;
    font-weight: bold;
    font-size: 30px;
    color: #fefefe;
    line-height: 70px;
    padding-left: 47px;
    margin-bottom: 20px;

    span {
      position: relative;
      z-index: 9;
    }

    &::after {
      z-index: 8;
      content: '';
      position: absolute;
      left: 25px;
      bottom: 5px;
      width: 366px;
      height: 23px;
      background: url('~@/img/agriculture/title_line.png') 100% 100%;
    }
  }

  .content {
    height: calc(100% - 100px);
    width: 100%;
    display: flex;

    .charts {
      position: relative;
      width: 600px;
      height: 100%;
    }

    .badge {
      position: absolute;
      right: 80px;
      top: -55px;
      display: flex;
      align-items: center;

      span {
        font-weight: normal;
        font-size: 21px;
        color: #ecf8ff;
        margin-left: 36px;
      }
    }

    #PurchasingChart {
      position: relative;
      z-index: 99;
      width: 500px;
      height: 410px;
    }
  }

  .buyer-list {
    padding-left: 24px;
    height: 100%;
    width: 1300px;
    box-sizing: border-box;
    overflow-x: hidden;
    overflow-y: auto;
    scroll-behavior: smooth;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    gap: 14px;

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      background: rgba(0, 212, 255, 0.05);
      border-radius: 2px;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(0, 212, 255, 0.2);
      border-radius: 2px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: rgba(0, 212, 255, 0.4);
    }

    .buyer-item {
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      width: 271px;
      height: 78px;
      background: rgba(31, 141, 162, 0.24);
      border: 1px solid rgba(83, 184, 255, 0.24);
      padding: 14px 0 0 14px;

      .name {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-weight: 500;
        font-size: 18px;
        color: #ffffff;
        line-height: 18px;
        height: 20px;
      }

      .num {
        transition: all 0.3s ease;
        white-space: nowrap;
        position: relative;
        z-index: 1;

        .amount {
          font-size: 24px;
          color: #fff;
          font-weight: bold;
        }

        .unit {
          font-size: 14px;
          color: #fff;
          font-weight: bold;
        }
      }

      &:hover {
        .name {
          color: #e2e8f0;
        }

        .num {
          color: #4fd1c5;
        }
      }

      &.active {
        .name {
          color: #f4a900;
        }

        .num {
          .amount {
            color: #f4a900;
          }

          .unit {
            color: #f4a900;
          }
        }
      }
    }
  }
}
</style>
